import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.env_name !== 'local') {
  Sentry.init({
    dsn: "https://73e44ff79ca020b4a8ce4542a0371f7c@o210964.ingest.us.sentry.io/4508726724067328",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(
        {
          maskAllText: false, // Masks all text on the page
          blockAllMedia: false, // Blocks all media (images, videos, etc.) from being recorded
        }
      ),
    ],
    environment: environment.env_name,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['https://dev.api.smartfunder.co.za/', 'https://api.nedbankeducation.co.za/',],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    profilesSampleRate: 0.5,
    debug: false, // Set to true to enable debug mode
  });
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection({ eventCoalescing: true })], })
  .catch(err => console.error(err));
